import styled from 'styled-components';


export const ModalText = styled.p`
    color: #333333;
    font-size: 14px;
    line-height: 22px;
    font-family: "Jost", sans-serif;
    text-align: center;
`;

export const ModalTitle = styled.h4`
    color: #083F44;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 600;
    line-height: 30px;
    text-align: center;
    margin-top: 30px;
    margin-bottom:20px;
`;

export const ModalButton = styled.div`
    display: flex;
    gap:30px;
    justify-content: center;
`;

export const PriceCol = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
    
    @media screen and (max-width: 767px){
        flex-wrap: wrap;
    }
`;

export const OtherBtn = styled.div`
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 500;
    line-height: 20px;
    background:#01606F ;
    box-shadow: 0px 5px 10px #0000000D;
    border-radius: 10px;
    padding: 14px 16px;
    display: inline-flex;
    max-width: 56px;
    text-align: center;
    justify-content: center;
`;